
import React, { useContext, useState, useEffect, useCallback } from 'react';
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Card, CardBody } from '@progress/kendo-react-layout';
import { LocalizationContext, UserContext } from '../../contexts';
import { useHistory } from 'react-router-dom';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import './index.scss';
import { useRepositoryHook } from '../../hooks';
import { Button } from '@progress/kendo-react-buttons';
import { FormInput } from './form-components.jsx';

export default function NewItem({ }) {

    const handleSubmit = (dataItem) => console.log(JSON.stringify(dataItem, null, 2));
    const [localization] = useContext(LocalizationContext);
    const history = useHistory();
    const [isValid, setIsValid] = useState(false);
    const [isButtonClickable, setIsButtonClickable] = useState(false);
    const [value, setValue] = useState(false);
    const [newNairobiId, setNewNairobiId] = useState(false);
    const [user] = useContext(UserContext);
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [showWarningDialog, setShowWarningDialog] = useState(false);
    const [showCustomDialog, setShowCustomDialog] = useState(false);
    const [customValueToDisplay, setCustomValueToDisplay] = useState(null);
    const { labels } = localization;

    const {
        importItem
    } = useRepositoryHook();

    const handleNewItem = () => {
        setShowDeleteDialog(false);
        history.push('/newItem');
        setValue(null);
    }

    // const handleConfirmClick = () => {
    //     history.push('/repository/all/' + newNairobiId);
    // };

    const handleCloseDialog = () => {
        setShowWarningDialog(false);
        setShowCustomDialog(false);
    };

    const urlPatternValidation = URL => {
        const regex = new RegExp('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?');
        return regex.test(URL);
    };

    const onFieldChange = async (url) => {
        await importItem(url, user.displayName).then((result) => {
            if (result && !result.includes(':')) {
                setNewNairobiId(result);
                setShowDeleteDialog(true);
            }
            else if (result.includes(':')) {
                setCustomValueToDisplay(result);
                setShowCustomDialog(true);
            }
            else if (result === null || result === "") {
                setShowWarningDialog(true);
            }

        }).catch((err) => {
            setShowWarningDialog(true);
        }
        );
    }

    return (
        <div className={'app-repository_item_editor new-item-form'}>
            <span className="form-item">
                {showDeleteDialog && <Dialog onClose={handleNewItem} title={false} >
                    <p><strong>{labels.pagesManagement.forms.added_successfully}</strong></p>
                    <DialogActionsBar>
                        {/* <button className="k-button k-primary" onClick={handleConfirmClick}>{labels.pagesManagement.forms.confirm}</button> */}
                        <a className="edit-button" href={`${window.location.protocol}//${window.location.host}/repository/all/${newNairobiId}`}>{labels.pagesManagement.forms.added_successfully_edit}</a>
                        <button className="k-button" onClick={handleNewItem}>{labels.pagesManagement.forms.add_new_item}</button>
                    </DialogActionsBar>
                </Dialog>}
            </span>
            <span className="form-item-wrapper">
                {showWarningDialog && <Dialog onClose={handleNewItem} title={false} >
                    <p>{labels.pagesManagement.forms.warning}</p>
                    <DialogActionsBar>
                        <button className="k-button k-primary" onClick={handleCloseDialog}>{labels.pagesManagement.forms.confirm}</button>
                    </DialogActionsBar>
                </Dialog>}
            </span>
            <span className="form-item-wrapper">
                {showCustomDialog && <Dialog onClose={handleNewItem} title={false} >
                    <p>{customValueToDisplay}</p>
                    <DialogActionsBar>
                        <button className="k-button k-primary" onClick={handleCloseDialog}>{labels.pagesManagement.forms.confirm}</button>
                    </DialogActionsBar>
                </Dialog>}
            </span>

            <Form onSubmit={handleSubmit}
                render={() => (
                    <FormElement horizontal={true} style={{ width: '100%' }}>
                        <fieldset className={'k-form-fieldset'} >
                            <Card id="section-info">
                                <CardBody className={'new_item_card'}>
                                    <Field
                                        component={FormInput}
                                        id={'contextURL'}
                                        name={'contextURL'}
                                        validationMessage={isValid ? '' : localization.labels.repositoryManagement.validators.invalidUrl}
                                        label={localization.labels.repositoryManagement.item.contextURL}
                                        onChange={(event) => {
                                            if (urlPatternValidation(event.value)) {
                                                setIsButtonClickable(true);
                                                setIsValid(true);
                                            }
                                            setValue(event.value);
                                        }}
                                    />

                                    <Button className="new_item k-button" disabled={!isButtonClickable} primary={true} onClick={(event) => {
                                        onFieldChange(value);
                                    }}>{localization.labels.repositoryManagement.newItem.new_item_catalog}</Button>

                                </CardBody>
                            </Card>
                            <Card>
                                <CardBody className={'new_item_details'}>
                                    {localization.labels.repositoryManagement.newItem.intro}
                                    <dl>
                                        <dt>LO -</dt>
                                        <dd>https://lo.cet.ac.il/player/?document=1234567-abcd-1234-abcd-123456abcdef</dd>
                                        <dd>https://lo.cet.ac.il/player/?document=1234567-abcd-1234-abcd-123456abcdef&language=ar</dd>

                                        <dt>{localization.labels.repositoryManagement.newItem.kotar} -</dt>
                                        <dd>
                                            https://school.kotar.cet.ac.il/KotarApp/Viewer.aspx?nBookID=123456789
                                        </dd>

                                        <dt>{localization.labels.repositoryManagement.newItem.itu} -</dt>
                                        <dd>
                                            https://itu.cet.ac.il?p=1234
                                        </dd>

                                        <dt>{localization.labels.repositoryManagement.newItem.presentation} -</dt>
                                        <dd>
                                            https://itu-presentation.cet.ac.il?p=1234
                                        </dd>

                                        <dt>{localization.labels.repositoryManagement.newItem.tarbutil} -</dt>
                                        <dd>
                                            https://tarbutil.cet.ac.il?p=1234
                                        </dd>

                                        <dt>{localization.labels.repositoryManagement.newItem.teachers} -</dt>
                                        <dd>
                                            https://itu-teachers.cet.ac.il?p=1234
                                        </dd>

                                        <dt>{localization.labels.repositoryManagement.newItem.wp929} -</dt>
                                        <dd>
                                            https://www.929.org.il/page/123/post/1234
                                        </dd>
                                        <dd>
                                            https://pages.929.org.il/aaaaa
                                        </dd>

                                        <dt>{localization.labels.repositoryManagement.newItem.learning} -</dt>
                                        <dd>
                                            https://learning.cet.ac.il/player/abcd12345678901234567890
                                        </dd>

                                        <dt>{localization.labels.repositoryManagement.newItem.botikra} -</dt>
                                        <dd>
                                            https://botikra.cet.ac.il/s/abc1234567
                                        </dd>
                                    </dl>
                                </CardBody>
                            </Card>
                        </fieldset>
                    </FormElement>
                )}
            ></Form>
        </div>
    )
}